<template>
  <div>
    <StepModel
      :ui="uiBaseStep"
      :name="STEP_NAMES.balanceTransfer"
      
        ui-title="Consolidate your non-Deem Credit Card balances into the Deem Credit Card"
      ui-error-message="Please review the fields marked in red"
      :ui-button-text="getMainActionText"
    >
     
 <FieldsetModel :ui="uiNoticeFieldset" :name="FIELDSET_NAMES.doubleSecureNotice">
          <PlainText>
            <p>You are eligible for a balance transfer of AED {{eligibleBalanceTransferAmt}}. Choose the suitable option to apply.</p>
            <p>
             <ul>
               <li>BT-Direct - Consolidate your non-Deem Credit Card balances into the Deem Credit Card with interest-free period of first 6 months (first 6 billing cycles)</li>
               <li>BT-Epp - Consolidate your non-Deem Credit Card balances into the Deem Credit Card and repay in easy installments of up to 12 months with Zero processing fees</li>
             </ul>
            </p>
           
          </PlainText>
        </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="`FIELDSET_NAMES.balanceTransfer`"
        :ui-fake-rerender="getSupplementaryCards.length"
        ui-columns="2"
      >
        <!-- Fieldset render explodes when doesn't have any children -->
        <!-- Which it will be true when there are no supplementary cards -->
        <!-- With this spam we prevent it from exploding -->
        <span />
        <SupplementaryCard
          v-for="(supplementaryCard, index) in getSupplementaryCards"
          :key="`${supplementaryCard.btCreditCardNumber}-${index}`"
          :title="`Balance Transfer Card ${index+1}`"
          :name="supplementaryCard.btCreditLimit"
          :amount="`Transfer Amount: AED ${supplementaryCard.btRequestAmount}`"
          :on-edit="() => editSupplementaryCard(index)"
          :on-remove="() => removeSupplementaryCard(index)"
        />
      </FieldsetModel>
<div v-if="removeAddAnotherButton">
   <FieldsetModel
        :ui="uiBaseFieldset"
        name="addNewBtCardButton"
        :presence="!showSupplementaryForm"
      >
        <Button
          type="button"
          color="hollow"
          :click="displaySupplementaryForm"
        >{{ getAddButtonText }}</Button>
      </FieldsetModel>
</div>
     
 
    <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.btType" ui-title="Enter the details of Credit Card for Balance Transfer (BT)" :presence="showSupplementaryForm" >
 <UiWrapper :name="FIELD_NAMES.btType">
            <Choice
              :options="[
                {
                  value: 'BT-Direct',
                  label: 'BT-Direct',
                },
                 {
                  value: 'BT-EPP',
                  label: 'BT-EPP',
                },
              ]"
            />
          </UiWrapper>
 </FieldsetModel>  
     
  <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.balanceTransfer"
   ui-columns="2"   
   :presence="showSupplementaryForm">
          <!-- <UiWrapper
            :name="FIELD_NAMES.btBankName"
            label="Bank/Financial institution Name"
           

          >
            <InputText />
          </UiWrapper> -->
          <UiWrapper
              :name="FIELD_NAMES.btBankName"
              label="Bank/Financial institution Name"
              
              :validations="[
                {
                  errorMessage: 'This field must not be empty',
                  condition: notEmptyCondition,
                  name: 'institution-filled',
                },
              ]"
            >
              <Suggest
                placeholder="Bank/Financial institution Name"
                :exact-match="true"
                :get-formatted-item="formatMatchedString"
                :get-suggestions="getBanksForBt"
              />
            </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.btCreditCardNumber"
            label="Credit Card number (16-digit)"
            :validations="creidtCardValidation"
          >
            <InputText  :maxlength="maxlength" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.btCreditLimit"
            label="Credit Card Limit (AED)"
              :validations="[
          {
            'errorMessage': 'Invalid characters',
            'condition': patternCondition(DIGIT_CHARS),
            'name': 'invalid-chars',
          },
        ]"
            
          >
            <InputText  />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.btTransferAmount"
            label="Balance Transfer request amount"
              :validations="[
          {
             'errorMessage': 'Invalid characters',
            'condition': patternCondition(DIGIT_CHARS),
            'name': 'invalid-chars',
          },
        ]"
          >
            <InputText />
          </UiWrapper>
          
        </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        name="saveOrBtCard"
        :presence="showSupplementaryForm"
      >
        <Button type="button" color="hollow" :click="saveSupplementaryCard">Save</Button>
      </FieldsetModel>
      <FieldsetModel :ui="uiBaseFieldset" name="limitExceedFieldset">
      <p id="limitExceedMsg" ></p>
    </FieldsetModel>
    </StepModel>
  </div>
</template>

<script>
// Models

import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
// // Shared Comps
// import FieldsetAppointmentAddress from "@/forms/components/card/credit-card/steps/fieldsets/appointment-date";
import StepAdditionalInformation from "@/forms/components/shared/steps/additional-information";
import FieldsetAppointmentDate from "@/forms/components/cards/stp-card/steps/fieldsets/appointment-date";

import {
  ADD_BALANCE_TRANSFER,
  EDIT_BALANCE_TRANSFER,
  REMOVE_BALANCE_TRANSFER,
    SET_BT_TRANSFER_LIMIT
} from "@/lib/constants/mutations";
// Ui Components
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest,
  SupplementaryInfo,
  SupplementaryCard,
  Button,
} from "@dunia/ui";

// Utils
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Constants
import FIELD_NAMES from "@/forms/constants/field-names";
import { isFutureDateCondition, withinMonthRange } from "@/forms/conditions";
import sharedComponentMixin from "@/forms/components/shared/shared-component-mixin";
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import {
  DIGIT_CHARS,
  NAMES_CHARS,
  ADDRESS_CHARS,
  CREDIT_CARD_NUMBER_LENGTH,
} from "@/forms/constants/onboarding-logic";
import { USE } from "@/forms/constants/nbc-logic";
import store from "@/store";
import { SET_OFFER_REJECTED } from "@/lib/constants/mutations";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";

import flowManager from "@/lib/services/flow-manager";
export default {
  name: "BalanceTransfer",

  mixins: [FormComponentMixin, sharedComponentMixin],

  components: {
    // Components
    InputSlide,
    PlainText,

    StepModel,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName,
    CheckWrapper,
    SupplementaryInfo,
    SupplementaryCard,
    Button,
  },
  props: {
    maxlength: {
      type: Number,
      default: 16,
    },
    creidtCardValidation: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-card-number-only-digits",
        },

        {
          errorMessage: "Your credit card have 16 digits",
          condition: conditions.patternCondition(CREDIT_CARD_NUMBER_LENGTH),
          name: "check-is-mobile-length",
        },
      ],
    },
  },
  data: () => ({
    showSupplementaryForm: false,
    editingSupplementaryCard: -1,
    DIGIT_CHARS,
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {
    getSupplementaryCards() {
      const { $store } = this;
      const { balanceTransfers } = $store.state.formData;
      return balanceTransfers;
    },

    getAddButtonText() {
      return this.getSupplementaryCards.length >= 1
        ? "Add another"
        : "Add card";
    },

    getMainActionText() {
      return this.getSupplementaryCards.length >= 1 ? "Next" : "No, thanks";
    },
    removeAddAnotherButton() {
      if (this.getSupplementaryCards.length <= 3) {
        return true;
      } else {
        return false;
      }
    },
    mappingValueToField() {
      return [
        ["bankName", FIELD_NAMES.btBankName],
        ["creditCardNumber", FIELD_NAMES.btCreditCardNumber],
        ["cardLimit", FIELD_NAMES.btCreditLimit],
        ["btRequestAmount", FIELD_NAMES.btTransferAmount],
        ["btType", FIELD_NAMES.btType],
      ];
    },

    getCurrentCardIndex() {
      return this.editingSupplementaryCard !== -1
        ? this.editingSupplementaryCard + 1
        : this.getSupplementaryCards.length + 1;
    },
    eligibleBalanceTransferAmt() {
      let eligibleAmount
      var fixedIncome =
        typeof this.$store.state.incomeFixed != undefined
          ? parseInt("" + this.$store.state.incomeFixed + "")
          : 0;
      var bureauScore =
        typeof this.$store.state.bureauScore != undefined
          ? parseInt("" + this.$store.state.bureauScore + "")
          : 0;
      var prescreenedAmount =
        typeof this.$store.state.preScreendedAmount != undefined
          ? parseInt("" + this.$store.state.preScreendedAmount + "")
          : 0;
      if (fixedIncome >= 5000) {
        if (
          (fixedIncome < 8000 || fixedIncome >= 8000) &&
          bureauScore >= 600 &&
          bureauScore <= 650
        ) {
         
          eligibleAmount=(40/100) * prescreenedAmount;
           store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (
          fixedIncome < 8000 &&
          bureauScore >= 650 &&
          bureauScore <= 700
        ) {
          eligibleAmount= (60/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (
          fixedIncome >= 8000 &&
          bureauScore >= 650 &&
          bureauScore <= 700
        ) {
          eligibleAmount= (70/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (
          fixedIncome < 8000 &&
          bureauScore >= 700 &&
          bureauScore <= 750
        ) {
          eligibleAmount=(70/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (
          fixedIncome >= 8000 &&
          bureauScore >= 700 &&
          bureauScore <= 750
        ) {
          eligibleAmount=(80/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (fixedIncome < 8000 && bureauScore > 750) {
          eligibleAmount=(70/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        } else if (fixedIncome >= 8000 && bureauScore > 750) {
          eligibleAmount=(90/100) * prescreenedAmount;
            store.commit(SET_BT_TRANSFER_LIMIT,{btTrnsferLimit:eligibleAmount});
          return eligibleAmount;
        }
      }
    },
    isLimitExceeded() {
      if (this.$store.state.limitExceeded) {
        return "Requested amount for balance transfer is higher than the approved balance transfer limit.";
      }
    },
  },

  methods: {
    async saveSupplementaryCard(e) {
      e.preventDefault();

      await flowManager.forceValidationsCurrentStep();
      if (!flowManager.isValidCurrentStep) return;

      const card = {};
      this.mappingValueToField.forEach(([name, fieldName]) => {
        card[name] = this.fieldValues(fieldName);
        this.resetFields([fieldName])();
      });

      this.showSupplementaryForm = false;
      let commitToUse = ADD_BALANCE_TRANSFER;

      if (this.editingSupplementaryCard !== -1) {
        card.index = this.editingSupplementaryCard;
        this.editingSupplementaryCard = -1;
        commitToUse = EDIT_BALANCE_TRANSFER;
      }

      const { $store } = this;
      $store.commit(commitToUse, card);
    },

    editSupplementaryCard(index) {
      this.editingSupplementaryCard = index;

      const { $store } = this;
      const cardToEdit =
        $store.state.formData.balanceTransfers[this.editingSupplementaryCard];

      this.mappingValueToField.forEach(([name, fieldName]) => {
        const fieldCard = this.getField(fieldName, { allFields: true });
        console.log(fieldCard);
        fieldCard.onChange(cardToEdit[name]);
      });

      this.$nextTick(function a() {
        this.displaySupplementaryForm();
      });
    },

    removeSupplementaryCard(index) {
      const { $store } = this;
      $store.commit(REMOVE_BALANCE_TRANSFER, index);
    },

    displaySupplementaryForm() {
      this.showSupplementaryForm = true;
    },

    finishCallback() {
      this.showEndPage({
        title: "Great!✌️",
        actions: [{ click: END_FORM, label: "Go to my account" }],
      });
    },
  },
    watch: {
    isLimitExceeded(value) {
      var p = document.getElementById("limitExceedMsg");
      if (p) {
        p.innerHTML = typeof value !== "undefined" ? value : "";
      }
    }
  }
};
</script>
